var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "goodsfreightReduction" },
    [
      _c("Filtersearch", {
        ref: "Filtersearchref",
        attrs: { list: _vm.Filtersearchlist, fromdata: _vm.from1 },
        on: { Refresh: _vm.Refresh, search: _vm.search },
        scopedSlots: _vm._u([
          {
            key: "right",
            fn: function () {
              return [
                _c(
                  "el-button",
                  {
                    attrs: {
                      type: "warning",
                      icon: "el-icon-upload2",
                      disabled: _vm.disabledExport,
                    },
                    on: { click: _vm.onHandleExport },
                  },
                  [_vm._v("导出")]
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(
        "div",
        { staticClass: "auto-table-flex" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "multipleTable",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData,
                height: "100%",
                border: true,
                "header-cell-style": {
                  color: "#333333",
                  background: "#EFF6FF",
                },
                "tooltip-effect": "dark",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  type: "index",
                  width: "80",
                  align: "center",
                  label: "序号",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "logistics_name",
                  align: "center",
                  label: "城市仓",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "business_name",
                  align: "center",
                  label: "集配中心",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "obj_type_text",
                  align: "center",
                  label: "减免类型",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "discount_object",
                  align: "center",
                  label: "减免对象",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "enabled_member_text",
                  align: "center",
                  label: "生效用户",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "start_time_text",
                  align: "center",
                  label: "生效时间",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(scope.row.start_time_text) +
                            "-" +
                            _vm._s(scope.row.end_time_text) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "discount_text",
                  align: "center",
                  label: "折扣\n",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "status_text",
                  align: "center",
                  label: "状态\n",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "create_time_text",
                  align: "center",
                  label: "创建时间",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "fy" },
        [
          _c("el-pagination", {
            attrs: {
              type: "primary",
              background: "",
              "current-page": _vm.currentPage,
              "page-sizes": [10, 20, 50, 100],
              "page-size": 50,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _c("GoodsDetails", { ref: "GoodsDetailsref" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }